import { FaRegBookmark } from "react-icons/fa";
import { FiShare2 } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import moment from "moment";

/** Format API date (YYYY-MM-DD or ISO) as dd/mm/yyyy without day/month swap */
function formatDisplayDate(dateValue) {
  if (!dateValue) return "";
  const m = moment(
    dateValue,
    [
      "YYYY-MM-DD",
      "YYYY/MM/DD",
      "DD/MM/YYYY",
      "DD-MM-YYYY",
      "DD MMM YYYY",
      moment.ISO_8601,
    ],
    true,
  );
  return m.isValid() ? m.format("DD/MM/YYYY") : "";
}

const SponseredKidCard = ({
  data,
  onViewProfile,
  user_id,
  super_admin_id,
  updateKidToBeSponsor,
}) => {
  let {
    avatar_url,
    amount,
    for_months,
    name,
    date_of_birth,
    join_date,
    address,
    category_name,
    mentored_on_date,
    full_name,
    category_color,
    mentoring_left_date,
    id,
    kid_id,
    state,
    mentor,
    mentor_name,
  } = data;
  const location = useLocation();

  // Get background color based on category_name
  const getCategoryBackgroundColor = (categoryName) => {
    if (!categoryName) return "#D3B1FF";
    const category = categoryName.toLowerCase();
    if (category === "hafiz") return "#a4b465";
    if (category === "communal violence") return "#fca470";
    if (category === "orphans") return "#94b088";
    if (category === "mob lynching") return "#e27878";
    if (category === "police atrocity") return "#F6EFBD";
    if (category === "impoverish") return "#bd90a9";
    if (category === "demolition") return "#96b1ab";
    if (category === "refugees") return "#bda887";
    if (category === "disaster") return "#ABE0F0";
    return "#bda887";
  };

  const bgColor = getCategoryBackgroundColor(category_name);
  const year = date_of_birth ? new Date(date_of_birth).getFullYear() : "";
  const shortAddress = address ? address.slice(-10) : "";

  const isLessThanOneDay = moment(mentoring_left_date).isBefore(
    moment().add(1, "days"),
  );
  const daysLeft = moment(mentoring_left_date).diff(moment(), "days");
  const message =
    daysLeft < 30 ? `${daysLeft} days left` : "More than 30 days left";

  // Calculate age from date_of_birth
  let age = "";
  if (date_of_birth) {
    const birthYear = new Date(date_of_birth).getFullYear();
    const currentYear = new Date().getFullYear();
    age = `${currentYear - birthYear}Y`;
  }

  // Truncate name: if space exists, show only the first word; if first word > 10 chars, cut to 10 and add dot
  let displayName = name;
  if (name) {
    const firstWord = name.split(" ")[0];
    if (firstWord.length > 10) {
      displayName = firstWord.slice(0, 10) + ".";
    } else {
      displayName = firstWord;
    }
  }

  return (
    <div
      style={{
        background: bgColor,
        borderRadius: "30px",
        boxShadow: "0 5px 15px rgba(0,0,0,0.07)",
        padding: 0,
        width: 279,
        minHeight: super_admin_id && updateKidToBeSponsor ? 520 : 452,
        height: super_admin_id && updateKidToBeSponsor ? 520 : 452,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        justifyContent: "flex-end",
        overflow: "hidden",
        transition: "none",
        WebkitTapHighlightColor: "transparent",
        touchAction: "pan-y",
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        cursor: "pointer",
      }}
      className="sponsored-card"
      onClick={() => onViewProfile(kid_id || id)}
    >
      {/* Image area */}
      <div
        style={{
          width: "100%",
          height: 255,
          background: data.avatar_url ? "none" : "#e6f5e6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          position: "absolute",
          top: 0,
          left: 0,
          pointerEvents: "auto",
        }}
      >
        <img
          src={avatar_url || "./child/noImg.png"}
          alt={name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 0,
          }}
        />
      </div>

      {/* Card content at the bottom */}
      <div
        style={{
          width: "100%",
          padding: "0rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-end",
          marginTop: 256,
          height: "176px",
          pointerEvents: "auto",
        }}
      >
        {/* Name */}
        <div
          style={{
            fontWeight: 550,
            fontSize: 28,
            color: "#293E4F",
            marginTop: 0,
            marginBottom: 20,
            textAlign: "left",
            fontFamily: "Poppins",
            width: "100%",
            lineHeight: 1.1,
            alignItems: "center",
            textAlign: "center",
            justifyContent: "center",
            width: "100%",
            pointerEvents: "auto",
          }}
        >
          {displayName}
          &nbsp;
          <span style={{ fontSize: 14, color: "#293E4F", fontWeight: "300" }}>
            {age && <span>{age}</span>}
            {age && state && (
              <span style={{ margin: "0 2px", fontSize: 10 }}>, </span>
            )}
            {state && <span>{state}</span>}
          </span>
        </div>

        {/* Category badge */}
        <div
          style={{
            background: "rgba(255, 255, 255, 0.3)",
            color: "#333",
            fontSize: 12,
            fontWeight: 600,
            fontFamily: "Inter",
            borderRadius: 24,
            padding: "4px 18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "fit-content",
            margin: "0 auto 10px auto",
            minHeight: 20,
            boxSizing: "border-box",
            letterSpacing: 0.2,
            pointerEvents: "auto",
          }}
        >
          {category_name}
        </div>

        {/* Mentor Name (replaces Monthly Expenses) */}
        <p
          style={{
            color: "#293E4F",
            fontSize: "12px",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
            fontFamily: "Inter",
            margin: "4px auto 12px auto",
            pointerEvents: "auto",
          }}
        >
          Mentor: {mentor_name || mentor || full_name || "Anonymous"}
        </p>

        {/* Sponsored Info Block */}
        <div
          style={{
            width: "100%",
            margin: "0 0 12px 0",
            padding: 0,
            pointerEvents: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div style={{ flex: 1, textAlign: "center" }}>
              <div style={{ color: "#293E4F", fontSize: 12, fontWeight: 400 }}>
                Sponsored From:
              </div>
              <div style={{ color: "#293E4F", fontWeight: 600, fontSize: 12 }}>
                {mentored_on_date ? formatDisplayDate(mentored_on_date) : ""}
              </div>
            </div>
            <div style={{ flex: 1, textAlign: "center" }}>
              <div style={{ color: "#293E4F", fontSize: 12, fontWeight: 400 }}>
                Sponsored Until:
              </div>
              <div style={{ color: "#293E4F", fontWeight: 600, fontSize: 12 }}>
                {mentoring_left_date
                  ? formatDisplayDate(mentoring_left_date)
                  : ""}
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 0,
              paddingTop: 4,
              width: "100%",
            }}
          >
            <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  background: "#293e4f",
                  borderRadius: 40,
                  color: "#fdc512",
                  fontWeight: 400,
                  fontSize: 12,
                  padding: "8px 28px",
                  textAlign: "center",
                  minWidth: 90,
                  display: "inline-block",
                }}
              >
                {for_months} Months
              </div>
            </div>
            <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  background: "#23a295",
                  borderRadius: 24,
                  color: "#fff",
                  fontWeight: 400,
                  fontSize: 12,
                  padding: "8px 28px",
                  textAlign: "center",
                  minWidth: 90,
                  display: "inline-block",
                }}
              >
                {amount ? `₹${amount}` : ""}
              </div>
            </div>
          </div>
        </div>

        {/* Move to Sponsor — super admin only, expired sponsorships */}
        {super_admin_id &&
          updateKidToBeSponsor &&
          mentoring_left_date &&
          moment(mentoring_left_date, [
            "YYYY-MM-DD",
            "YYYY/MM/DD",
            moment.ISO_8601,
          ]).isBefore(moment(), "day") && (
            <button
              style={{
                width: "100%",
                background: "#293E4F",
                color: "#24a395",
                border: "none",
                borderRadius: 18,
                padding: "0px 0",
                fontWeight: 500,
                marginTop: 10,
                padding: 10,
                fontSize: 16,
                marginTop: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(41, 157, 142, 0.08)",
                transition: "background 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                updateKidToBeSponsor(kid_id || id, name);
              }}
            >
              Move to Sponsor
            </button>
          )}

        {/* View Profile Button */}

        {/* Expiring On Link */}
      </div>

      <style>{`
        .sponsored-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
        }

        @media (max-width: 768px) {
          .sponsored-card {
            width: 100%;
            max-width: 100%;
            margin: 0 0 1.5rem 0;
          }
        }

        @media (max-width: 480px) {
          .sponsored-card {
            margin: 0 0 1rem 0;
          }
        }

        @media (min-width: 769px) and (max-width: 991px) {
          .sponsored-card {
            max-width: 280px;
          }
        }
      `}</style>
    </div>
  );
};

export default SponseredKidCard;
